module.exports = __webpack_public_path__ + "img/placeholder-portrait.2724585.jpg";